var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"hide-header":"","centered":"","size":"lg","hide-footer":"","id":"modal-image"},on:{"hide":_vm.closeModal}},[(_vm.src)?_c('div',{staticClass:"modal-container"},[_c('img',{directives:[{name:"img-fb",rawName:"v-img-fb",value:(_vm.src),expression:"src"}],attrs:{"alt":""}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-067a19fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/base/component/image-modal.vue
// module id = null
// module chunks = 